var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card root" },
    [
      _c("Title", { attrs: { title: "Confirme a sua limpeza" } }),
      _vm._v(" "),
      _c("OrderReview"),
      _vm._v(" "),
      _c("ReschedulePreference"),
      _vm._v(" "),
      _vm.professional.professional_rating &&
      _vm.professional.professional_rating.has_products
        ? _c("ProductsPreference")
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-green btn-confirmation",
            class: { "btn--loading": _vm.preloader },
            attrs: { disabled: _vm.preloader },
            on: { click: _vm.submit }
          },
          [_c("span", [_vm._v("ir para pagamento")])]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-go-back",
            class: { "btn--loading": _vm.preloader },
            attrs: { disabled: _vm.preloader },
            on: { click: _vm.unsetOrderConfirmation }
          },
          [_c("span", [_vm._v("voltar")])]
        )
      ]),
      _vm._v(" "),
      _c("WontHaveInstantSupport", {
        attrs: {
          visible: _vm.showWontHaveInstantSupportDialog,
          date: _vm.date
        },
        on: {
          accept: function() {
            return _vm.wontHaveInstantSupport(true)
          },
          reject: function() {
            return _vm.wontHaveInstantSupport(false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dfbfbd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dfbfbd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Confirmation/Index.vue
// module id = null
// module chunks = 